import { render } from "./TicketDetailForm.vue?vue&type=template&id=9a7013c6"
import script from "./TicketDetailForm.vue?vue&type=script&lang=js"
export * from "./TicketDetailForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__